enum TypeDossierProduction {
    PlasticMaterialStock = "PlasticMaterialStock" ,
    NonStockInCatalog = "NonStockInCatalog" ,
    NonStockNotInCatalog = "NonStockNotInCatalog" ,
    Veneer = "Veneer" ,
    Solid = "Solid" ,
    LacquerIntern = "LacquerIntern" ,
    LacquerExtern = "LacquerExtern" ,
    ShowroomKitchen = "ShowroomKitchen" ,
    Other = "OtherNA"
}

export default TypeDossierProduction;